<template>
  <div class="row c-item-name">
    <div v-if="item?.[src]" class="go-left mr12">
      <c-img class="w45 h45 radius10" :src="getFullImage(item?.[src])" />
    </div>
    <div>
      <div
        class="c-item-name-top"
        v-html="item?.[top] || 'N/A'"
        :title="item?.[top] || 'N/A'"
      ></div>
      <div v-if="isBottom">{{ item?.[bottom] || "N/A" }}</div>
    </div>
    <!-- <div class="title-container">
      <span v-html="item?.[top]"></span>
    </div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
// import { useI18n } from "vue-i18n";
import { getFullImage } from "@/services/utils/helper.util";

export default defineComponent({
  name: "c-item-name",

  props: {
    item: { type: Object, default: () => ({}) },
    top: { type: String, default: "name" },
    bottom: { type: String, default: "code" },
    isBottom: { type: Boolean, default: false },
    src: { type: String, default: "thumbnail" },
  },

  emits: [],

  setup() {
    // const { t } = useI18n();

    return {
      //   t,
      getFullImage,
    };
  },
});
</script>
<style lang="scss" src="./style.scss"></style>
